export default "__VITE_ASSET__voVcDkaI__"